// import $ from "jquery";
// import "slick-carousel";
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
import 'bootstrap/js/dist/tab';
import 'bootstrap/js/dist/collapse';

class sliderSwiper {

    constructor() {
        this.sliderInit();
        this.events();
        this.paginationClass = $('.slider-02-control .slider__pagination');
    }

    sliderInit() {
        Swiper.use([Navigation, Pagination, Autoplay]);
        
        var myswiper = new Swiper('.slider-02', {
            spaceBetween: 36,
            autoHeight: true,
            speed: 500,
            grabCursor: false,
            allowTouchMove: true,
            pagination: {
                el: '.slider-02-control .slider__pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.slider-02-control .slider__button-next',
                prevEl: '.slider-02-control .slider__button-prev',
            },
            breakpoints: {
                767:{
                    allowTouchMove: true,
                },
            },
            on: {
                resize: function(){
                    if($(window).width() > 767)
                        this.destroy();
                },
                slideChange: function(){
                    this.update();
                },
            },
        });

        const swiperImg = document.querySelector('.imgSwipe').swiper;
        swiperImg.on("touchMove", function(swip){
            var swiptoval='';
            if(swip.swipeDirection=='next')
                swiptoval = swip.realIndex+1;
            else
                swiptoval = swip.realIndex-1;
            const swiperText = document.querySelector('.textSwipe').swiper;
            swiperText.slideTo(swiptoval, 200);
            //this.pagination.update();
            //swiperImg.slideTo(swiptoval, 400);
        });
        const swiperText = document.querySelector('.textSwipe').swiper;
        swiperText.on("touchMove", function(swip){
            var swiptoval='';
            if(swip.swipeDirection=='next')
                swiptoval = swip.realIndex+1;
            else
                swiptoval = swip.realIndex-1;

            const swiperImg = document.querySelector('.imgSwipe').swiper;
            swiperImg.slideTo(swiptoval, 200);
            //this.pagination.update();
            //swiperText.slideTo(swiptoval, 400);
        });
        
    }
        
    resizeEvents() {
        $(window).on('resize', () => {
            if ($(window).width() < 768) {
                this.sliderInit();
            }   
       });
    }

    events() {
        this.resizeEvents();
    }
}

export default sliderSwiper;
new sliderSwiper();
